import { Notyf } from "notyf";

//GERER LES ERREURS AXIOS
export default function handleAxiosError(error) {
  // 1 - Cas : l'API a répondu (même avec une erreur)
  if (error.response) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.data?.message || "Erreur serveur",
      details: error.response.data || null,
    };
  }

  // 2 - Cas : requête envoyée mais aucune réponse reçue
  if (error.request) {
    return {
      success: false,
      code: null, // pas de status HTTP
      message: "Impossible de contacter le serveur",
      details: null,
    };
  }

  // 3 - Cas : erreur dans Axios avant même l'envoi de la requête
  return {
    success: false,
    code: null,
    message: error.message || "Erreur inconnue",
    details: null,
  };
}

//FORMATER UNE DATE
export const formaterDate = (dateISO) => {
  if (!dateISO) return null;

  const date = new Date(dateISO);

  const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(
    date.getMonth() + 1
  ).padStart(2, "0")}/${date.getFullYear()} ${String(date.getHours()).padStart(
    2,
    "0"
  )}:${String(date.getMinutes()).padStart(2, "0")}`;
  return formattedDate;
};

//METTRE UN NOMBRE A 2 DECIMALES
export const roundToCents = (value) => Math.round(value * 100) / 100;

export const loginConfig = {
  method: "post",
  url: `${import.meta.env.VITE_API_URL}login_check`,
  data: {
    username: import.meta.env.VITE_EVE_EDUCATION_API_USERNAME,
    password: import.meta.env.VITE_EVE_EDUCATION_API_PASSWORD,
  },
  headers: { "Content-Type": "application/json" },
};

export const notyf = new Notyf({
  position: {
    x: "center",
    y: "bottom",
  },
  duration: 0, //illimitée
  dismissible: true,
});

///// ----------------DONNEES PAR DEFAUT DU FORMULAIRE ////////////////////////////////////////

export const registerDefaultEmpty = {
  //12 champs lg1
  status: "",
  lastname: "",
  firstname: "",
  nationality: "",
  profession: "",
  country: "",
  city: "",
  address: "",
  email: "",
  phone: "",
  whatsapp: "",
  facebook: "",
  information: "",
  //1 champ partagé
  //custody: "",
  // 12 champs lg2
  secondStatus: "",
  secondLastname: "",
  secondFirstname: "",
  secondNationality: "",
  secondProfession: "",
  secondCountry: "",
  secondCity: "",
  secondAddress: "",
  secondEmail: "",
  secondPhone: "",
  secondWhatsapp: "",
  secondFacebook: "",
  //enfants (1 enfant = 1 objet)
  children: [
    {
      lastname: "",
      firstname: "",
      gender: "",
      dateOfBirth: "",
      placeOfBirth: "",
      nationality: "",
      residencePlace: "",
      address: "",
      city: "",
      country: "",
      grade: "",
      IEFClasses: "",
      liveClasses: "",
      oldSchools: "",
      disorder: "",
      otherInfo: "",
    },
  ],
};

export const registerDefaultFilled = {
  //12 champs lg1
  status: "father",
  lastname: "NOMpère",
  firstname: "Prénompère",
  nationality: "Française",
  profession: "Développeur",
  country: "France",
  city: "Paris",
  address: "rue des Champs Élysées",
  email: "eve.education.dev@gmail.com",
  phone: "+336",
  whatsapp: "+336",
  facebook: "Un profil",
  information: "Une info super importante",
  //1 champ partagé
  //custody: "father",
  // 12 champs lg2
  secondStatus: "mother",
  secondLastname: "NOMmère",
  secondFirstname: "Prénommère",
  secondNationality: "Allemande",
  secondProfession: "Boulangère",
  secondCountry: "Allemagne",
  secondCity: "Berlin",
  secondAddress: "rue de Hambourg",
  secondEmail: "eve.education.dev@gmail.com",
  secondPhone: "+337",
  secondWhatsapp: "+337",
  secondFacebook: "Un autre profil",
  //enfants (1 enfant = 1 objet)
  children: [
    {
      lastname: "NOM enfant",
      firstname: "Prénom enfant",
      gender: "M",
      dateOfBirth: "2010-05-14",
      placeOfBirth: "Paris",
      nationality: "Française",
      residencePlace: "lg1",
      address: "",
      city: "",
      country: "",
      grade: "CM2",
      IEFClasses: "",
      liveClasses: "",
      oldSchools: "",
      disorder: "non",
      otherInfo: "",
    },
  ],
};

//////////------------FONCTIONS DE VALIDATION ////////////////////////////////////////////////////////////////////////////////////////

export const verificationEmail = (email) => {
  const regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};

export const verificationNomPrenom = (nomPrenom) => {
  //un nom ou prénom ne contient que des lettres fr et < 50 caractères (bdd)
  const regex = /^[a-zA-Zà-ÿÀ-ß-]+([\s-][a-zA-Zà-ÿÀ-ß-]+)*$/; // Lettres, y compris accentuées, espaces et tirets
  return nomPrenom.length <= 50 && regex.test(nomPrenom);
};

export const validationLongueurMax = (valeur, longueurMax) => {
  return valeur.length <= longueurMax;
};

export const validationSelect = (valeur, propositions) => {
  return propositions.includes(valeur);
};

export const validationRequired = (valeur) => {
  return valeur.trim() !== "";
};

export const validationTelephone = (telephone) => {
  const phoneRegex = /^[\d\s+()\-]+$/; // Regex pour vérifier les chiffres, espaces, et +
  return phoneRegex.test(telephone);
};

export const validationConfirmation = (valeur1, valeur2) => {
  return valeur1 === valeur2;
};

export const validationDate = (dateString) => {
  if (typeof dateString !== "string") return false;

  // Regex stricte pour AAAA-MM-JJ (année à 4 chiffres uniquement)
  const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
  if (!regex.test(dateString)) return false;

  // Vérifie si la date est valide en JS (évite 30/02 ou autres incohérences)
  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const openWA = () => {
  //ouvrir le WA situé dans le footer

  const wa = document.querySelector(
    "div[class*=styles-module_whatsappButton__IWx9V]"
  );
  wa.click();
};

export const format = (width) => {
  if (width >= 1366) {
    return "PC";
  } else if (width > 600) {
    return "Tablette";
  } else {
    return "Mobile";
  }
};

export const responsiveWidth = (width) => {
  return {
    video: {
      PC: 656,
      Tablette: width * 0.9,
      Mobile: width * 0.9,
    },
  };
};

export const responsiveHeight = (width) => {
  return {
    video: {
      PC: 369,
      Tablette: (width * 0.9 * 9) / 16,
      Mobile: (width * 0.9 * 9) / 16,
    },
  };
};
